module.exports = __webpack_public_path__ + "static/appstore-e395a2d2e9044fd34e648bea8751be53.svg";